import Vue from "vue"
import wx from 'weixin-js-sdk'
import axios from 'axios'
//==============================StringUtil=================================
const StringUtil = {
  //是否为空判断
  isNull: function(text) {
    if (undefined == text) {
      return true;
    }
    if (text.length == "" || text.length == 0) {
      return true;
    }
    return false;
  }
};
Vue.prototype.StringUtil = StringUtil;
//==============================StringUtil=================================

//==============================Share分享=================================
const Share={
   wx:function(shareDataObj){
   	   // let shareUrl="http://www.vweb365.com/h5/case/20200521dengkang/#/vrbox";
   	  //  let shareUrl=location.href.split('#')[0];
	    axios.get('http://www.vweb365.com/php/wxshare/sample.php?url='+location.href.split('#')[0]).then(function(res){
	          let resdata=res.data;
	          wx.config({    
	          　　debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。　　
	          　　appId: resdata.appId, // 必填，公众号的唯一标    
	          　　timestamp: resdata.timestamp, // 必填，生成签名的时间戳
	          　　nonceStr: resdata.nonceStr, // 必填，生成签名的随机串
	          　　signature: resdata.signature,// 必填，签名
	              jsApiList: ["updateAppMessageShareData", "updateTimelineShareData",'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ','onMenuShareWeibo']//必填，需要使用的JS接口列表
	          });
	          //通过error接口处理失败验证
	          wx.error(function(err){
	               console.log("报错了"+err);
	               console.log(err);
	              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
	          });
	          //通过ready接口处理成功验证
	          wx.ready(function () {
	              //分享给好友 
	              wx.updateAppMessageShareData(shareDataObj);
	              // 分享到朋友圈
	              wx.updateTimelineShareData(shareDataObj);
	              console.log("调用分享接口ok");
	          });
	    }).catch(function(res){
	       console.log(res);
	    })
   },
   wx2:function(url,dataForWeixin){
			  axios.get('http://www.vweb365.com/php/wx/sample.php', {
			    params: {
			      url: location.href.split('#')[0]
			    },
			  }).then(res => {
			    console.log(res);
			    let resdata=res.data;
			    wx.config({
			      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
	          　　appId: resdata.appId, // 必填，公众号的唯一标    
	          　　timestamp: resdata.timestamp, // 必填，生成签名的时间戳
	          　　nonceStr: resdata.nonceStr, // 必填，生成签名的随机串
	          　　signature: resdata.signature,// 必填，签名
	              jsApiList: ["updateAppMessageShareData", "updateTimelineShareData",'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ','onMenuShareWeibo']//必填，需要使用的JS接口列表
			    })
			    wx.ready(function () {
	              //分享给好友 
	              wx.updateAppMessageShareData(shareDataObj);
	              // 分享到朋友圈
	              wx.updateTimelineShareData(shareDataObj);
	              console.log("调用分享接口ok")
			      // wx.onMenuShareAppMessage({
			      //   title: dataForWeixin.title,
			      //   desc: dataForWeixin.desc,
			      //   link: dataForWeixin.linkurl,
			      //   imgUrl: dataForWeixin.img,
			      //   trigger: function trigger(res) { },
			      //   success: function success(res) {
			      //     console.log('已分享');
			      //   },
			      //   cancel: function cancel(res) {
			      //     console.log('已取消');
			      //   },
			      //   fail: function fail(res) {
			      //     console.log(JSON.stringify(res));
			      //   }
			      // });
			      // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
			     /* wx.onMenuShareTimeline({
			        title: dataForWeixin.title,
			        link: dataForWeixin.linkurl,
			        imgUrl: dataForWeixin.img,
			        trigger: function trigger(res) {
			          console.log('用户点击分享到朋友圈');
			        },
			        success: function success(res) {
			          console.log('已分享');
			        },
			        cancel: function cancel(res) {
			          //alert('已取消');
			        },
			        fail: function fail(res) {
			          alert(JSON.stringify(res));
			        }
			      });*/
			      // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
			      /*wx.onMenuShareQQ({
			        title: dataForWeixin.title,
			        desc: dataForWeixin.desc,
			        link: dataForWeixin.linkurl,
			        imgUrl: dataForWeixin.img,
			        trigger: function trigger(res) {
			          //alert('用户点击分享到QQ');
			        },
			        complete: function complete(res) {
			       // alert(JSON.stringify(res));
			        },
			        success: function success(res) {
			          //alert('已分享');
			        },
			        cancel: function cancel(res) {
			          //alert('已取消');
			        },
			        fail: function fail(res) {
			          //alert(JSON.stringify(res));
			        }
			      });*/
			      // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
			      wx.onMenuShareWeibo({
			        title: dataForWeixin.title,
			        desc: dataForWeixin.desc,
			        link: dataForWeixin.linkurl,
			        imgUrl: dataForWeixin.img,
			        trigger: function trigger(res) {
			          //alert('用户点击分享到微博');
			        },
			        complete: function complete(res) {
			          // alert(JSON.stringify(res));
			        },
			        success: function success(res) {
			          console.log('已分享微博');
			        },
			        cancel: function cancel(res) {
			          // alert('已取消');
			        },
			        fail: function fail(res) {
			          // alert(JSON.stringify(res));
			         // console.log(JSON.stringify(res));
			        }
			      });
			    })
			    wx.error(function (res) {
			      console.log(JSON.stringify(res)+"微信验证失败");
			      // alert(JSON.stringify(res)+"微信验证失败");
			    });
			  })
   }
};
Vue.prototype.Share = Share;
//==============================Share分享=================================

export default {};



//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = null
// module chunks = 